import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../Auth"
import { TripPlanRequestReportsList } from "../../TripPlanRequests"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { generatePath } from "../../router-utils"

export default function TripPlanRequests() {
	return (
		<>
			<Helmet>
				<title>Trip Plan Requests Report</title>
			</Helmet>
			<Breadcrumbs
				title="Trip Plan Requests Report"
				items={[
					[generatePath("/trip-plan-requests"), "Trip Plan Requests"],
					["", "Reports"],
				]}
			/>
			<ForbidUnlessAuthorized
				permission={PERMISSIONS.MANAGE_TRIP_PLAN_REQUESTS}
			>
				<TripPlanRequestReportsList />
			</ForbidUnlessAuthorized>
		</>
	)
}
